const { isLocalHost } = require("./utils/Utils");

exports.authconfig = {
    Auth: {
        Cognito: {
            userPoolClientId: '2t6ld7skl81n76n95be6ndrdl5',
            userPoolId: 'us-east-1_ANsTOsB9s',
            loginWith: { // Optional
                oauth: {
                    domain: 'sna-spr-admin-prod.auth.us-east-1.amazoncognito.com',
                    scopes: ["openid", "profile"],
                    // redirectSignIn: ['https://admin.productregistration.sony.com/callback'],
                    redirectSignIn: isLocalHost ? ['http://localhost:3000/callback'] : ['https://admin.productregistration.sony.com/callback', 'https://admin.prodreg-stage.electronics.sony.com/callback'],
                    // redirectSignOut: ['https://admin.productregistration.sony.com'],
                    redirectSignOut: isLocalHost ? ['http://localhost:3000'] : ['https://admin.productregistration.sony.com', 'https://admin.prodreg-stage.electronics.sony.com'],
                    responseType: 'code',
                },
                //   username: 'true',
                //   email: 'false', // Optional
                //   phone: 'false', // Optional
            },
            // storage: window.sessionStorage
        }
    }
};

// exports.API = 'https://xny4pqepcd.execute-api.us-east-1.amazonaws.com/api';
exports.API = false ? 'http://localhost:5000' : 'https://xny4pqepcd.execute-api.us-east-1.amazonaws.com/api';
